export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
export const CREATE_PROFILE = 'CREATE_PROFILE';
export const GET_PROFILE = 'GET_PROFILE';
export const CREATE_JOB = 'CREATE_JOB';
export const COMPANY_JOBS = 'COMPANY_JOBS'
export const GET_USERS = 'GET_USERS';
export const CREATE_PROFILE_USER = 'CREATE_PROFILE_USER'
export const DATA = 'DATA'
export const GET_JOBS = 'GET_JOBS'
export const GET_JOB_DETAILS = 'GET_JOB_DETAILS';
export const APPLICATION ='APPLICATIONS';
export const RELATED_JOBS = 'RELATED_JOBS';
export const POST_APPLICATIONS = "POST_APPLICATIONS";
export const GET_APPLICATION = 'GET_APPLICATION';
export const REFER_USER = 'REFER_USER';
export const GET_REFER  ='GET_REFER';
export default AUTH